import {
    GtmService,
    FlowId,
    type EventParams
} from 'tradera/services/google-tagmanager-service';

export interface SyiEventParams extends EventParams {
    form_name?: string;
    syi_session_id?: string;
}

type trackSYIFormProps = {
    eventName: string;
    formName?: string;
    parameters?: Omit<
        SyiEventParams,
        'form_name' | 'syi_session_id' | 'timestamp'
    >;
};

let syiSessionId: string | null = null;

const createSessionId = () => {
    const randomDigits = Math.random().toString().slice(2, 10);
    const timestamp = Date.now();
    return `${randomDigits}${timestamp}`;
};

export const trackSyiForm = ({
    eventName,
    formName,
    parameters = {}
}: trackSYIFormProps) => {
    if (!syiSessionId) {
        // eslint-disable-next-line better-mutation/no-mutation
        syiSessionId = createSessionId();
        GtmService.trackGA4(FlowId.SYI, 'form_start', {
            form_name: 'syi_draft',
            syi_session_id: syiSessionId,
            timestamp: Date.now()
        });
    }

    GtmService.trackGA4(FlowId.SYI, eventName, {
        ...parameters,
        form_name: formName,
        syi_session_id: syiSessionId,
        timestamp: Date.now()
    });
};
